// extracted by mini-css-extract-plugin
export default {"tableContainer":"Reports_tableContainer__6NI+r","pageTabContaner":"Reports_pageTabContaner__ly5NJ"};